import { merge } from 'lodash';

import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import PageContainer from '../../containers/PageContainer';

const ReimbursementDetailsPageContainer = props => {
  const { breadcrumbs = [], children, style, ...rest } = props;

  return (
    <PageContainer
      {...rest}
      style={merge(style || {}, { minHeight: '100%' })}
      title={<PageBreadcrumbs items={breadcrumbs} />}
    >
      {children}
    </PageContainer>
  );
};

export default ReimbursementDetailsPageContainer;
